"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistingApplicationChoiceError = void 0;
/** `APIResponse.error` values returned by the existing-application choice endpoint. */
var ExistingApplicationChoiceError;
(function (ExistingApplicationChoiceError) {
    ExistingApplicationChoiceError["EXISTING_APPLICATION_NOT_FOUND"] = "EXISTING_APPLICATION_CHOICE_EXISTING_APPLICATION_NOT_FOUND";
})(ExistingApplicationChoiceError || (exports.ExistingApplicationChoiceError = ExistingApplicationChoiceError = {}));
